import { ReactNode } from 'react';

import { cn } from 'support/helpers/cn/cn';
import { StatusBubble, StatusBubbleVariant } from 'components/Display/StatusBubble/StatusBubble';

export const Header = ({
  title,
  description,
  descriptionClassName,
  status,
}: {
  title: ReactNode;
  description?: ReactNode;
  descriptionClassName?: string;
  status: StatusBubbleVariant;
}) => (
  <div>
    <div className="flex items-center justify-between gap-2">
      <h1 className="text-sm leading-5 font-bold text-gray-700">{title}</h1>
      <StatusBubble variant={status} />
    </div>
    <p className={cn('text-sm text-gray-700 empty:hidden', descriptionClassName)}>{description}</p>
  </div>
);
